import { render, staticRenderFns } from "./SettingsNavigation.vue?vue&type=template&id=58fd6240"
import script from "./SettingsNavigation.vue?vue&type=script&lang=ts"
export * from "./SettingsNavigation.vue?vue&type=script&lang=ts"
import style0 from "./SettingsNavigation.vue?vue&type=style&index=0&id=58fd6240&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports